export enum ResponsiveBreakPoints {
  _Desktop = 1600,
  DesktopMedium = 1440,
  DesktopMin = 1320, // 1080 + 240 (width of left nav)
  ExtraSmallMobile = 320,
  Mobile = 768,
  Notebook = 1268,
  SmallMobile = 375,
  Tablet = 1024,
}

export const MAX_CONTENT_WIDTH = '1040px';
